import {useEffect} from 'react';
import './DialogflowMessenger.css';

export const ChatIcon = () => {
  useEffect(() => {
    const scriptUrl =
      'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js';

    const isScriptLoaded = (url: string) => {
      return document.querySelector(`script[src="${url}"]`) !== null;
    };

    const loadScript = (url: string) => {
      return new Promise<void>((resolve, reject) => {
        if (isScriptLoaded(url)) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () =>
          reject(new Error(`Failed to load script ${url}`));
        document.body.appendChild(script);
      });
    };

    const initializeDialogflowMessenger = () => {
      const dfMessenger = document.createElement('df-messenger');
      dfMessenger.setAttribute('location', 'europe-west1');
      dfMessenger.setAttribute('project-id', 'aro-env-prod');
      dfMessenger.setAttribute(
        'agent-id',
        'c397bd76-0fd5-456c-a987-becc5114fd52',
      );
      dfMessenger.setAttribute('language-code', 'fr');
      dfMessenger.setAttribute('max-query-length', '-1');

      const chatBubble = document.createElement('df-messenger-chat-bubble');
      chatBubble.setAttribute('chat-title', 'Chatbot Aro');
      dfMessenger.appendChild(chatBubble);

      document.body.appendChild(dfMessenger);
    };

    loadScript(scriptUrl)
      .then(() => {
        console.log('Script loaded successfully or already present.');
        initializeDialogflowMessenger();
      })
      .catch(error => {
        console.error('Error loading script:', error);
      });

    return () => {
      const dfMessenger = document.querySelector('df-messenger');
      if (dfMessenger) {
        document.body.removeChild(dfMessenger);
      }
    };
  }, []);
  return null;
};
